import { render } from "./ReportPieChart.vue?vue&type=template&id=9259c62a&ts=true"
import script from "./ReportPieChart.vue?vue&type=script&lang=ts"
export * from "./ReportPieChart.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/vidict/ott-platform/procricket-admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__